<app-vista-seguridad>
    <section class="col-md-7 col-sm-12 p-4 rounded bg-white shadow m-auto">
        <header class="mb-4">
            <h2 class="h4">Cambio de contraseña</h2>
            <p class="text-left">Ingrese su nueva contraseña</p>
        </header>
        <form [formGroup]="formCambiarContra" (ngSubmit)="openModal()">
            <div class="form-row mb-2">
                <div class="col-12 p-0">
                    <input formControlName="clave_acceso" type="password" class="form-control cambiar-contra-input rounded-0 mb-3 shadow"
                        placeholder="Nueva contraseña" ngbTooltip="Usa al menos 8 caracteres, un carácter especial (%$+!.), una mayúscula y un número." />
                    <div id="mensaje" *ngIf="!formCambiarContra.controls.clave_acceso.valid && (formCambiarContra.get('clave_acceso').dirty)">
                        <p class="small text-danger mt-1 position-absolute font-weight-bold" text-right>Contraseña
                            debil</p>
                    </div>
                </div>
                <div class="col-12 p-0">
                    <input formControlName="clave_acceso_confirmacion" type="password" class="form-control cambiar-contra-input rounded-0 shadow"
                        placeholder="Confirmar contraseña" />
                </div>
                <div class="col">
                    <p class="small text-left mt-3">Usa al menos 8 caracteres, un carácter especial (%$+!.), una
                        mayúscula y un número.</p>
                </div>
            </div>
            <div class="form-row mb-2">
                <div class="col-12">
                    <button type="submit" [disabled]="!formCambiarContra.valid" class="btn text-white cambiar-contra-btn-principal w-100">Guardar
                        cambios</button>
                </div>
            </div>
        </form>
    </section>
</app-vista-seguridad>